var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "object-menu-container",
      style: [_vm.xPosition, _vm.yPosition],
      attrs: { "data-app": "" }
    },
    [
      _c("div", { staticClass: "object-list-title" }, [
        _vm._v(_vm._s(_vm.$tc("SelectObject", 1)))
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-container scroll-fire-fox" },
        _vm._l(_vm.connections, function(item) {
          return _c("join-cable-menu-item", {
            key: item.cb_id,
            attrs: { connection: item },
            on: {
              click: function($event) {
                return _vm.executeAction($event)
              }
            }
          })
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32131c4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32131c4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectMenu/JoinCableMenu/JoinCableMenu.vue
// module id = null
// module chunks = 